import React, { useState, useContext } from "react";
import "./tasks-filter-mob.component.scoped.sass";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";
import { icons } from "src/statics/icons";
import { TasksContext } from "src/store";
import FilterTaskButton from "src/components/filter-task-button/filter-task-button.component";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" className="dialog-title">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: "#fbfcfe"
  },
}))(MuiDialogContent);

export default function TasksFilterDialog(props: any) {
  const [t] = useTranslation();
  const { createBuildingsIco } = icons;
  const {activeFilters, setActiveFilter, clearActiveFilters, filters} = useContext(TasksContext);
  const [activeTasks, setActiveTasks] = useState(activeFilters);

  const toggleActiveFilter = (handledFilter: any) => {
    const activeDialogfilters = [...activeTasks];
    const handledFilterIndex = activeTasks.indexOf(handledFilter);
    if (handledFilterIndex > -1) {
      activeDialogfilters.splice(handledFilterIndex, 1);
    } else {
      activeDialogfilters.push(handledFilter);
    }
    setActiveTasks(activeDialogfilters);
  }

  const isActiveTask = (task : any) => {
    return (activeTasks.includes(task.nameDe) || activeTasks.includes(task.nameEn))
  }

  const handleClose = (save: boolean = false) => {
    props.onClose();
  };

  const applyFilter = () => {
    clearActiveFilters();
    activeTasks.map((task: string) => {
      setActiveFilter(task);
      return task;
    });
    props.onClose();
  };

  return (
    <Dialog
      disableBackdropClick
      onClose={handleClose.bind(null, false)}
      aria-labelledby="customized-dialog-title"
      open={props.open}
      fullWidth={true}
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose.bind(null, false)} classes={{closeButton: "close-button"}}>
        {t('details')}
      </DialogTitle>
      <DialogContent dividers>
        <div className="filters-content">
          {filters.map((task: any, index: number) => (
            <div className="task" key={index}>
              <FilterTaskButton
                task={task}
                toggleActiveFilter={toggleActiveFilter}
                activeFilters={activeTasks}
                state={isActiveTask(task)? 'active': ''
                }
              />
            </div>
          ))}
        </div>
        <Button
          variant="contained"
          className="btn-save"
          onClick={applyFilter}
        >
          <div className="btn-flex"><img
            alt="icon"
            className="icon icon-refresh"
            src={createBuildingsIco}
          />
            {t("apply")}
          </div>
        </Button>
      </DialogContent>
    </Dialog>
  );
}
